import * as getters from './getters';
import { HOME_FEED_TAB_KEYS } from '~/utils/home-feed-tab-keys';

import actions from './actions';
import mutations from './mutations';
const state = () => ({
  feedTabs: [
    {
      key: HOME_FEED_TAB_KEYS.FOR_YOU,
      titleKey: 'community',
      index: 0,
    },
    {
      key: HOME_FEED_TAB_KEYS.NEWS,
      titleKey: 'news',
      index: 1,
    },
  ],
  activeFeedTab: {
    key: HOME_FEED_TAB_KEYS.FOR_YOU,
    titleKey: 'community',
    index: 0,
  },
  homeForYouFeedCursor: null,
  homeForYouFeed: null,
  newPostNumber: null,
  homeForYouFeedLoading: false,
  nextHomeForYouPostsLoading: false,
  error: null,
  deleteUserPost: { data: null, loading: false, error: null },
  homeNewsFeed: null,
  homeNewsFeedLoading: false,
  homeNewsFeedError: null,
  homeNewsFeedCursor: null,
  nextHomeNewsPostsLoading: false,
});

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
